import PropTypes from 'prop-types'

import {Map} from 'immutable'
import {useState} from 'react'
import {connect} from 'react-redux'

import Item from '../../../../../dashboard/src/components/corp_max/item/Item'

import {
  goToHouseholdDetail,
  goToQuarterbackClientDetail,
  proAddMorePath,
  proEditCompoundItemPath,
  proEditItemPath,
  proNewCompoundItemPath,
  proNewItemPath,
  proViewItemPath,
  quarterbackClientAddMorePath,
  quarterbackClientEditCompoundItemPath,
  quarterbackClientEditItemPath,
  quarterbackClientNewCompoundItemPath,
  quarterbackClientNewItemPath,
  quarterbackClientViewItemPath
} from '../../../../../lib/navigation/proNavigation'
import {useEverplanData} from '../../../../../lib/hooks'
import {itemBySlug} from '../../../../../lib/plan_data/item'
import {currentUserConfig} from '../../../../../lib/userTools'

const ProItemController = props => {
  const {itemResponses, newContacts} = useEverplanData(props.params.everplanId)

  const [hideItem, setHideItem] = useState(false)

  const exit = () => {
    setHideItem(true) // needed to be set to stop the flickering of an empty item when deleting a response group.

    if (props.userConfig.get('quarterback'))
      goToQuarterbackClientDetail({clientSeatId: props.params.clientSeatId})
    else
      goToHouseholdDetail({clientSeatId: props.params.clientSeatId})
  }

  const pathParams = ({elementId, groupId}) => ({
    ...props.params,
    elementId,
    groupId,
    path: props.location.pathname
  })

  const addMorePath = ({elementId, groupId}) => (props.userConfig.get('quarterback') ?
    quarterbackClientAddMorePath(pathParams({elementId, groupId})) :
    proAddMorePath(pathParams({elementId, groupId}))
  )

  const editCompoundItemPath = ({elementId, groupId}) => (props.userConfig.get('quarterback') ?
    quarterbackClientEditCompoundItemPath(pathParams({elementId, groupId})) :
    proEditCompoundItemPath(pathParams({elementId, groupId}))
  )

  const editItemPath = ({elementId, groupId}) => (props.userConfig.get('quarterback') ?
    quarterbackClientEditItemPath(pathParams({elementId, groupId})) :
    proEditItemPath(pathParams({elementId, groupId}))
  )

  const newCompoundItemPath = ({elementId, groupId}) => (props.userConfig.get('quarterback') ?
    quarterbackClientNewCompoundItemPath(pathParams({elementId, groupId})) :
    proNewCompoundItemPath(pathParams({elementId, groupId}))
  )

  const newItemPath = ({elementId, groupId}) => (props.userConfig.get('quarterback') ?
    quarterbackClientNewItemPath(pathParams({elementId, groupId})) :
    proNewItemPath(pathParams({elementId, groupId}))
  )

  const viewItemPath = ({elementId, groupId}) => (props.userConfig.get('quarterback') ?
    quarterbackClientViewItemPath(pathParams({elementId, groupId})) :
    proViewItemPath(pathParams({elementId, groupId}))
  )

  const itemResponse = itemBySlug({items: itemResponses, itemSlug: props.params.itemSlug})
  const ownerships = itemResponse.get('owners')

  return (
  // `corp-max-controller` is here to ensure styling looks correct for compound items:
    <div className='pro-item-controller corp-max-controller'>
      <Item
        {...props}
        hideItem={hideItem}
        ownerships={ownerships}
        newContacts={newContacts}
        itemResponse= {itemResponse}
        addMorePath={addMorePath}
        editCompoundItemPath={editCompoundItemPath}
        editItemPath={editItemPath}
        exit={exit}
        newCompoundItemPath={newCompoundItemPath}
        newItemPath={newItemPath}
        viewItemPath={viewItemPath}
        context={'pro_client_dashboard'}
      />
    </div>
  )
}

ProItemController.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string
  }),
  params: PropTypes.object,
  userConfig: PropTypes.instanceOf(Map)
}

const mapStateToProps = state => {
  const userConfig = currentUserConfig(state.api)

  return {userConfig}
}

export default connect(mapStateToProps)(ProItemController)

